import type { CardProps } from '@chakra-ui/react'
import { Card, ListItem, OrderedList, Text } from '@chakra-ui/react'
import React from 'react'
import { useThemeColors } from 'hooks/useThemeColors'

type ContractNavigationProps = {
  data: { name: string; id: number; content: string }[]
  activeFile: { name: string; id: number; content: string }
  onFileClicked: ({ id, name }: { id: number; name: string; content: string }) => void
} & CardProps

export const ContractNavigation = ({
  data,
  activeFile,
  onFileClicked,
  ...props
}: ContractNavigationProps) => {
  const COLORS = useThemeColors()

  return (
    <Card p={8} w="fit-content" bgColor={COLORS.grey07} {...props}>
      <Text variant="title1regular">Contract Source Code</Text>
      <OrderedList mt={5} mx={0} stylePosition="inside">
        {data.map(({ name, id, content }) => (
          <ListItem
            // eslint-disable-next-line react/no-array-index-key
            key={`${name}-${id}`}
            color={COLORS.grey01}
            {...(activeFile.id === id && {
              fontWeight: 700,
              color: COLORS.dark01,
            })}
            onClick={() => {
              if (activeFile.id !== id) {
                onFileClicked({ id, name, content })
              }
            }}
            wordBreak="break-all"
            fontSize="16px"
            _notFirst={{ mt: 5 }}
            _hover={{ color: COLORS.dark01, cursor: 'pointer' }}
          >
            {name}
          </ListItem>
        ))}
      </OrderedList>
    </Card>
  )
}
